function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withRouter } from "next/router";
import { useState } from "react";
import MobileTabNavButton from "segments/desktop/core-components/mobile-tabs/mobile-tab-nav-button";
import MobileTabs from "segments/desktop/core-components/mobile-tabs/mobile-tabs";
import AssetComponent from "components/core/asset/asset-component";
import { XS, XS_L } from "constants/sizes";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import querystring from "querystring";
import { ACTIVE_TAB_ID } from "constants/query-params";
import { StyledUseCasesTabsMobileComponent } from "./use-cases-tabs-mobile-component.scss";
import DefaultProps from "../default-props";
const UseCasesTabsMobileComponent = (props)=>{
    var _router_asPath_split, _router_asPath;
    const [wasComponentEverVisible, setWasComponentEverVisible] = useState(false);
    const { buttonsColor, tabs, router } = props;
    const tabIds = tabs === null || tabs === void 0 ? void 0 : tabs.map((tab)=>{
        var _tab_tabId;
        return (_tab_tabId = tab === null || tab === void 0 ? void 0 : tab.tabId) !== null && _tab_tabId !== void 0 ? _tab_tabId : null;
    });
    const params = querystring.parse(router === null || router === void 0 ? void 0 : (_router_asPath = router.asPath) === null || _router_asPath === void 0 ? void 0 : (_router_asPath_split = _router_asPath.split("?")) === null || _router_asPath_split === void 0 ? void 0 : _router_asPath_split[1]);
    const activeTabId = params === null || params === void 0 ? void 0 : params[ACTIVE_TAB_ID];
    const getInitialSelectedTab = ()=>{
        if (tabIds === null || tabIds === void 0 ? void 0 : tabIds.includes(activeTabId)) {
            return tabIds === null || tabIds === void 0 ? void 0 : tabIds.indexOf(activeTabId);
        }
        return 0;
    };
    const [selectedTab, setSelectedTab] = useState(getInitialSelectedTab);
    const navigationItemRenderer = (tab, index)=>{
        return /*#__PURE__*/ _jsx(MobileTabNavButton, {
            label: tab.tabLabel,
            selected: selectedTab === index,
            theme: buttonsColor
        });
    };
    const carouselItemRenderer = (tab)=>{
        const { mobileAsset, images, mobileTextAlign } = (tab === null || tab === void 0 ? void 0 : tab.tabContent) || {};
        return /*#__PURE__*/ _jsxs("div", {
            className: "asset-and-paragraphs-wrapper",
            children: [
                /*#__PURE__*/ _jsx(AssetComponent, _object_spread({}, mobileAsset)),
                images === null || images === void 0 ? void 0 : images.map((paragraph)=>/*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, paragraph.fullParagraph), {
                        topic: {},
                        titleSize: XS_L,
                        textSize: XS,
                        mobileTextAlign: mobileTextAlign
                    })))
            ]
        });
    };
    return /*#__PURE__*/ _jsx(StyledUseCasesTabsMobileComponent, {
        className: "use-cases-tabs-mobile-component",
        children: /*#__PURE__*/ _jsx(MobileTabs, _object_spread_props(_object_spread({}, props), {
            selectedTab: selectedTab,
            setSelectedTab: setSelectedTab,
            wasComponentEverVisible: wasComponentEverVisible,
            setWasComponentEverVisible: setWasComponentEverVisible,
            navigationItemRenderer: navigationItemRenderer,
            carouselItemRenderer: carouselItemRenderer
        }))
    });
};
UseCasesTabsMobileComponent.defaultProps = DefaultProps;
export default withRouter(UseCasesTabsMobileComponent);
